export const gitCommitHash = '40b431f2';